import { render } from "./ReportUserPage.vue?vue&type=template&id=12a9d6c8"
import script from "./ReportUserPage.vue?vue&type=script&lang=js"
export * from "./ReportUserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__